import { create } from 'zustand'

interface BearState {
  bears: number
  increase: () => void
  decrease: () => void
}

export const useStore = create<BearState>((set) => ({
  bears: 0,
  increase: () => set((state) => ({ bears: state.bears + 1 })),
  decrease: () => set((state) => ({ bears: state.bears - 1 }))
}))

interface AuthState {
  accessToken: string
  refreshToken: string
  role: string
  Id: string
  username: string
}

export const useAuth = create<
  AuthState & {
    setAuth: (data: Partial<AuthState>) => void
  }
>((set) => ({
  accessToken: '',
  refreshToken: '',
  role: '',
  username: '',
  Id: '',
  setAuth: (data) => set(data)
}))
